import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";

const UserList = () => {
  const navigate = useNavigate();

  const users = [
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      gender: "Female",
      registeredDate: "01 March 2025",
      address: {
        country: "India",
        state: "Maharashtra",
        city: "Pune",
      },
      postedCars: 5,
      savedCars: 12,
    },
    {
      id: 2,
      name: "John Smith",
      email: "john@example.com",
      phone: "+91 9000011111",
      gender: "Male",
      registeredDate: "15 February 2025",
      address: {
        country: "India",
        state: "Maharashtra",
        city: "Mumbai",
      },
      postedCars: 2,
      savedCars: 7,
    },
  ];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>User Detail</TableCell>
            <TableCell>Gender</TableCell>
            <TableCell>Address</TableCell>
            <TableCell>Posted Cars</TableCell>
            <TableCell>Saved Cars</TableCell>
            <TableCell>Enable/Disable</TableCell>
            <TableCell>Registered Date</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {users.map((user) => (
            <TableRow hover key={user.id}>
              {/* USER DETAIL */}
              <TableCell className="click_action">
                <a
                  href="/manage-users/detail"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/manage-users/detail");
                  }}
                  className="user_block click_action"
                >
                  <figure>
                    <img
                      src="/static/images/user_placeholder.png"
                      alt="User"
                    />
                  </figure>
                  <p>
                    <b>{user.name}</b>
                    <span>{user.phone}</span>
                    <span>{user.email}</span>
                  </p>
                </a>
              </TableCell>

              {/* GENDER */}
              <TableCell>{user.gender}</TableCell>

              {/* ADDRESS */}
              <TableCell>
                {user.address.city}, {user.address.state},{" "}
                {user.address.country}
              </TableCell>

              {/* POSTED CARS */}
              <TableCell>{user.postedCars}</TableCell>

              {/* SAVED CARS */}
              <TableCell>{user.savedCars}</TableCell>

              {/* STATUS */}
              <TableCell>
                <SwitchToggle defaultChecked />
              </TableCell>
              
              <TableCell>{user.registeredDate}</TableCell>

              {/* ACTIONS */}
              <TableCell>
                <div className="table_actions v2">
                  <IconButton
                    onClick={() =>
                      navigate("/manage-users/detail")
                    }
                  >
                    <img src="/static/images/eye_icon.svg" alt="View" />
                  </IconButton>

                  <IconButton
                    onClick={() =>
                      navigate("/manage-users/edit")
                    }
                  >
                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                  </IconButton>

                  <IconButton>
                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer >
  );
};

export default UserList;
